module.exports = __webpack_public_path__ + "assets/img/22_298.95ca8a2a.jpg";